import { Radio, RadioGroup, RadioGroupProps } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form/lib/use-form"
import { useContext } from "react"
import { KeysOfType } from "~/utils/types"
import { EditingContext } from "../editingContext"
import { boolToYesNo, capitalize } from "../utils"
import { ReadOnlyInput } from "./ReadOnlyInput"

type YesNoInputProps<
  T extends Partial<Record<K, boolean | null>>,
  K extends KeysOfType<T, boolean | null>
> = Omit<RadioGroupProps, "value" | "error" | "children" | "onBlur"> & {
  form: UseFormReturnType<T>
  field: K
}

export const YesNoInput = <
  T extends Partial<Record<K, boolean | null>>,
  K extends KeysOfType<T, boolean | null>
>({
  form,
  field,
  onChange,
  ...props
}: YesNoInputProps<T, K>) => {
  const editing = useContext(EditingContext)

  return editing ? (
    <RadioGroup
      value={boolToYesNo(form.values[field])}
      onChange={(value) => {
        form.setFieldValue(field, (value === "yes") as T[K])
        form.clearFieldError(field)
        onChange && onChange(value)
      }}
      onBlur={() => form.validateField(field)}
      error={form.errors[field]}
      {...props}
    >
      <Radio value="yes" label="Yes" />
      <Radio value="no" label="No" />
    </RadioGroup>
  ) : (
    <ReadOnlyInput
      value={capitalize(boolToYesNo(form.values[field]))}
      error={field in form.errors}
      {...props}
    />
  )
}
